import { render, staticRenderFns } from "./BasePDFQuestionRenderer.vue?vue&type=template&id=11b5c452&scoped=true&"
import script from "./BasePDFQuestionRenderer.vue?vue&type=script&lang=js&"
export * from "./BasePDFQuestionRenderer.vue?vue&type=script&lang=js&"
import style0 from "./BasePDFQuestionRenderer.vue?vue&type=style&index=0&id=11b5c452&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b5c452",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11b5c452')) {
      api.createRecord('11b5c452', component.options)
    } else {
      api.reload('11b5c452', component.options)
    }
    module.hot.accept("./BasePDFQuestionRenderer.vue?vue&type=template&id=11b5c452&scoped=true&", function () {
      api.rerender('11b5c452', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BasePDFQuestionRenderer.vue"
export default component.exports